import {
  Button,
  Flex,
  InputSearch,
  Paper,
  Select,
  Text,
} from "@pillar-ui/core";
import { PAGE, RESTAURANT_TYPE_OPTIONS } from "../common/constants";
import { BigArrowLeft, Plus } from "@pillar-ui/icons";
import {
  useAppStateContext,
  useCreateNewStateContext,
  useFilterStateContext,
} from "../common/contexts";
import colors from "../styles/colors";

const Toolbar = ({ currentPage, setPage }) => {
  const { filterByName, filterByType, setFilterByName, setFilterByType } =
    useFilterStateContext();
  const { setIsOpenRestaurantEditor } = useAppStateContext();
  const { setRestaurantEditorData } = useCreateNewStateContext();
  const { setFilterById } = useFilterStateContext();

  return (
    <Paper
      p="3"
      background="Se10"
      width="100%"
      style={{ position: "sticky", left: 0, top: 100, zIndex: 99 }}
    >
      {currentPage === PAGE.LUCKY_GAMES && (
        <Paper
          onClick={() => setPage(PAGE.RESTAURANT)}
          style={{ paddingTop: 8, paddingBottom: 8 }}
        >
          <Flex items="center" gap="2">
            <BigArrowLeft width={32} height={32} color={colors.black} />
            <Text size="8" style={{ color: colors.black }}>
              {"Back"}
            </Text>
          </Flex>
        </Paper>
      )}
      {currentPage === PAGE.RESTAURANT && (
        <Flex direction="row" justify="between" gap="3">
          <Paper>
            <Flex direction="row" gap="2" items="center">
              <Paper style={{ flex: 1 }}>
                <InputSearch
                  placeholder="Tên quán"
                  variant="bordered"
                  value={filterByName}
                  onChange={(evt) => {
                    setFilterByName(evt.target.value);
                    setFilterById("");
                  }}
                  style={{ width: "100%" }}
                />
              </Paper>
              <Paper style={{ width: 130, flex: 1 }}>
                <Select
                  placeholder="Chọn món"
                  variant="bordered"
                  value={filterByType}
                  color="p"
                  onChange={(evt) => {
                    setFilterByType(evt.target.value);
                    setFilterById("");
                  }}
                >
                  {RESTAURANT_TYPE_OPTIONS.map((item, index) => {
                    return (
                      <option
                        key={`restaurant_type_filter_opt_${index + 1}`}
                        value={item.value}
                      >
                        {item.label}
                      </option>
                    );
                  })}
                </Select>
              </Paper>
            </Flex>
          </Paper>
          <Paper style={{ flex: 1, textAlign: "end" }}>
            <Button
              icon={<Plus />}
              variant="solid"
              color="p"
              onClick={() => {
                setRestaurantEditorData(null);
                setIsOpenRestaurantEditor(true);
              }}
              title="Thêm quán"
              style={{ width: 140, maxWidth: "35%" }}
            >
              {"Thêm quán"}
            </Button>
          </Paper>
        </Flex>
      )}
    </Paper>
  );
};

export default Toolbar;
